module.exports = __webpack_public_path__ + "img/mexico_noreste.06db17ef.png";